module.exports = __webpack_public_path__ + "img/viviane.d4a4a598.jpg";